import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import EmailModulePreview from "../../components/EmailModulePreview";
import {
  emailModulesList,
  emailModulesListNext,
  openEditorBreakdown,
  toggleEditorBreakdown,
} from "../../actions";

import styles from "./ModuleSearchSidebar.module.css";

export class ModuleSearchSidebar extends Component {
  constructor(props) {
    super(props);
    this.renderModule = this.renderModule.bind(this);
    this.dragStart = this.dragStart.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.onScroll = debounce(this.onScroll.bind(this), 300);
    // this.onScroll = this.onScroll.bind(this);
    this.scrollRef = createRef();
  }

  componentWillMount() {
    const templateId =
      this.props.email.EmailTemplate && this.props.email.EmailTemplate.id;
    if (templateId) {
      this.props.emailModulesList(
        this.props.accountId,
        {
          templateId,
        },
        true
      );
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    const templateId =
      this.props.email.EmailTemplate && this.props.email.EmailTemplate.id;
    if (templateId) {
      this.props.emailModulesList(
        this.props.accountId,
        {
          templateId,
          name: searchTerm,
        },
        true
      );
    }
  }

  onScroll(e) {
    if (
      this.scrollRef?.current?.scrollTop +
        this.scrollRef?.current?.clientHeight >
      this.scrollRef?.current?.scrollHeight - 50
    ) {
      this.props.emailModulesListNext(this.props.accountId);
    }
  }

  dragStart(e) {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData(
      "text/plain",
      "module:" + e.currentTarget.dataset.id
    );
    // this.props.openEditorBreakdown();
    this.closeBreakdownOnDragEnd = this.props.breakdown === false;
  }

  renderModule(module, index) {
    const { accountId } = this.props;

    return (
      <div
        key={module.id}
        className={styles.grabbable}
        data-id={module.id}
        draggable="true"
        onDragStart={this.dragStart}
      >
        <EmailModulePreview module={module} accountId={accountId} />
      </div>
    );
  }

  render() {
    const { emailModules } = this.props;

    return (
      <div className={styles.sidebar}>
        <input
          className={styles.search}
          type="search"
          placeholder="Search..."
          onChange={this.onSearch}
        />
        <div
          ref={this.scrollRef}
          className={styles.scroll}
          onScroll={this.onScroll}
        >
          {emailModules.map(this.renderModule)}
        </div>
      </div>
    );
  }
}

ModuleSearchSidebar.propTypes = {};

// Connect state data
function mapStateToProps(state) {
  const emailModules = state.pagination.emailModules.ids.map(
    (id) => state.entities.emailModule[id]
  );
  const { email, breakdown } = state.editor;

  // if(state.pagination.emailModules.ids.length>0){
  //     debugger;
  // }
  return {
    emailModules,
    email,
    breakdown,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailModulesList,
  emailModulesListNext,
  openEditorBreakdown,
  toggleEditorBreakdown,
})(ModuleSearchSidebar);
